export const PeriodicReviewFrequency = {
  ONE_YEAR: {key: "ONE_YEAR", duration: 12, label: "workflowValidation.periodicChoice.frequency.oneYear"},
  TWO_YEARS: {key: "TWO_YEARS", duration: 24, label: "workflowValidation.periodicChoice.frequency.twoYears"},
  THREE_YEARS: {key: "THREE_YEARS", duration: 36, label: "workflowValidation.periodicChoice.frequency.threeYears"}
};
